<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.plan_purchase && wrapper">
    <div class="banner center" style="max-width:1600px;">
        <div class="row freeze_height">
            <div class="col-2">
                <button class="button_icon button_icon_color" (click)="onAction(1)"
                    title="{{localService.languageContent.plan_purchase.download}}">
                    file_download
                </button>
            </div>
            <div class="col-4">
                <app-label [Text]="localService.languageContent.plan_purchase.taxable" />
                <span class="en" title="{{wrapper.content.v2}}"
                    [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (wrapper.content.v1 | number:'1.2-2')">
                </span>
            </div>
            <div class="col-3">
                <app-label [Text]="localService.languageContent.plan_purchase.tax" />
                <span class="en"
                    [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (wrapper.content.v5 | number:'1.2-2')">
                </span>
            </div>
            <div class="col-3">
                <app-label [Text]="localService.languageContent.plan_purchase.refunded" />
                <span class="en"
                    [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (wrapper.content.v4 | number:'1.2-2')">
                </span>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-md-4">
                <div class="row">
                    <div class="col-6">
                        {{localService.languageContent.plan_purchase.issued_on}}
                    </div>
                    <div class="col-3">
                        {{localService.languageContent.plan_purchase.taxable}}
                    </div>
                    <div class="col-3">
                        {{localService.languageContent.plan_purchase.tax}}
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                {{localService.languageContent.plan_purchase.inv_nbr}}
            </div>
            <div class="col-md-2">
                <div class="row">
                    <div class="col-12">
                        <button class="button_icon button_icon_color icon_adjust" (click)="onAction(9)"
                            style="top: 5px !important;">
                            refresh
                        </button>
                        {{localService.languageContent.plan_purchase.to_tax}}
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="row">
                    <div class="col-12">
                        {{localService.languageContent.plan_purchase.client_name}}
                    </div>
                </div>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="styled_row" *ngFor="let item of wrapper.items">
                <div class="row"
                    [ngStyle]="{'background-color' : item.v6 == PlanPurchaseInvoiceStatus.Refunded.toString() ? 'mistyrose' : 'inherit'}">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-6">
                                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(4,item.key)"
                                    title="{{localService.languageContent.plan_purchase.receipt}}">
                                    receipt
                                </button>
                                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(5,item.key)"
                                    title="{{localService.languageContent.plan_purchase.print}}">
                                    print
                                </button>
                                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(7,item.key)"
                                    title="{{localService.languageContent.common.send_to_phone}}">
                                    send_to_mobile
                                </button>
                                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(2,item.key)"
                                    title="{{localService.languageContent.common.upload_file}}">
                                    upload_file
                                </button>
                                <span class="en">
                                    {{item.v2 | date : 'dd-MMM-yyyy'}}
                                </span>
                            </div>
                            <div class="col-3 right">
                                <span class="en" title="{{item.v5}}"
                                    [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (item.v4 | number:'1.2-2')">
                                </span>
                            </div>
                            <div class="col-3 right">
                                <span class="en"
                                    [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (item.v14 | number:'1.2-2')">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <span class="en">
                            {{item.v1}}
                        </span>
                    </div>
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-12">
                                <button *ngIf="item.v8 && item.v8.length > 3" class="button_icon danger icon_adjust"
                                    title="{{localService.languageContent.table.remove}}"
                                    (click)="onAction(8,item.key)">
                                    cancel
                                </button>
                                <span class="en">
                                    {{item.v8}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-12">
                                <i class="material-icons icon_adjust">
                                    {{item.v11 == InteractionType.B2B.toString() ? 'business' : 'shopping_bag'}}
                                </i>
                                <span>
                                    {{item.v13}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging [paging]="wrapper.paging" [IsSimple]="true" [IsShowSimpleCalenderRange]="true"
        [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()" />
    <app-print *ngIf="IsPrint" [fileName]="fileName" [content]="printContent" (onPrinted)="onPrinted()" />
    <div>
        <app-send-to-phone *ngIf="isOpenSendToPhone" [(isOpen)]="isOpenSendToPhone" [key]="selectedId"
            [communicationTemplate]="CommunicationTemplate.InvoiceGenerated" />
    </div>
    <span style="display: none;">
        <button class="on_as_country_changed" (click)="onChangeAsCountry()">As Country Changed</button>
    </span>
</div>